import { ResourcelessPermissionId } from '@upright/common/iam/privilege/permission/types';
import { useHasResourcelessPrivilege } from '@upright/ui/api/iam/privilege/query-options';

/**
 * Whether the organisation's own page is open to the signed-in user. The page's rail row and the
 * labels that changed with it show only for them; everyone else keeps the labels they had.
 */
export function useHasSelfServeAccess() {
  return useHasResourcelessPrivilege(ResourcelessPermissionId.USE_SELF_SERVE_ACCESS).hasPrivilege;
}
